import { config } from '@/lib/env-helpers';
import { IS_LOCAL_HOST } from './dev-server.helper';

export const cookieSubdomain = (() => {
  if (IS_LOCAL_HOST) {
    return undefined;
  }

  if (config.IS_DEVELOP) {
    return '.internal.krispchats.com';
  }

  if (config.IS_STAGING) {
    return '.trial.krispchats.com';
  }

  if (config.IS_UAT) {
    return '.uat.calilio.com';
  }

  if (config.IS_PRODUCTION) {
    return '.calilio.com';
  }

  return undefined;
})();
